import { Component, ElementRef, ViewChild, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/dashboard/services/dashboard/dashbaord.service';

declare var bootstrap: any;

@Component({
  selector: 'app-text-with-one-image',
  templateUrl: './text-with-one-image.component.html',
  styleUrls: ['./text-with-one-image.component.css']
})
export class TextWithOneImageComponent {  
    
    @Input() data: any;

  }
